// External libraries
import React from 'react';
import { css } from '@emotion/core';
import { useStoreState } from 'easy-peasy';
import { SubmitButton as Button } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { getButtonCurrencyCode, getSubmitButtonContentKey } from './utils';

const SubmitButton = () => {
  useMountLogging('SubmitButton');
  const { value: accountType } = useStoreState(
    ({ form }) => form.onboardOption,
  );
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);
  const conversionData = useStoreState(({ api }) => api.currencyConversionData);
  const conversionSelection = useStoreState(({ form }) => {
    return form.currencyConversionSelection;
  });
  const contentKey = getSubmitButtonContentKey({
    accountType,
    conversionSelection,
  });
  const currency = getButtonCurrencyCode(conversionData, conversionSelection);

  return (
    <Button
      disabled={isFormSubmitting}
      styleOverrides={css({ marginBottom: '24px' })}
      value={getContent(contentKey, { currency })}
    />
  );
};

export { SubmitButton };
